import { MoneyPoolDeedTypeTransactional } from '../moneyPools'

interface IFundsItems {
    title: string
    members: number
    exist: number
    membership: number
    date: string
    status: string
    id: number
}

export const FundsItems: Array<IFundsItems> = [
    {
        id: 0,
        title: 'صندوق حضرت الزهرا (ص)',
        members: 3521,
        exist: 11000000,
        membership: 500000,
        date: '۲۷ اردیبهشت ۱۴۰۱',
        status: 'pending',
    },
]

export const TRANSACTION_STATE_INIT = 'init'
export const TRANSACTION_STATE_TOKENED = 'tknd'
export const TransactionStateInProgress = 'inpg'
export const TransactionStateToBank = 'tbnk'
export const TransactionStateSuccessful = 'scss'
export const TRANSACTION_STATE_UNSUCCESSFUL = 'unsc'

export const InProgressTransactionStatusText = 'In Progress Transaction'
export const DepositedTransactionStatusText = 'Deposited Transaction'
export const DepositedByManagerTransactionStatusText =
    'Deposited By Manager Transaction'
export const RegisteredByManagerTransactionStatusText =
    'Registered By Manager Transaction'

// A transaction the manager typed in (deed_type «ثبتی») moved no money through
// Hamyan, whichever way it points. The two directions used to read differently
// — «ثبت شده توسط مدیر» on a cash-in, a bare « مدیر» on a cash-out (Android's
// «انتقال به‌عهده مدیر», cut short) — which made one fact look like two.
const RECORDED_BY_MANAGER_LABEL = 'ثبت‌شده توسط مدیر'

export const TransactionStatusText: { [key: string]: string } = {
    [InProgressTransactionStatusText]: 'در حال واریز',
    [DepositedTransactionStatusText]: 'واریز شده',
    [DepositedByManagerTransactionStatusText]: RECORDED_BY_MANAGER_LABEL,
    [RegisteredByManagerTransactionStatusText]: RECORDED_BY_MANAGER_LABEL,
}
// Tone follows what the member should feel: money still on its way is the one
// state worth a second look (amber), arrived is good news (green), and «ثبتی»
// is a fact about bookkeeping, not an alert (neutral).
export const TransactionStatusTextDesign: { [key: string]: string } = {
    [InProgressTransactionStatusText]: 'bg-warning-soft text-warning-on',
    [DepositedTransactionStatusText]: 'bg-success-2 text-success-on',
    [DepositedByManagerTransactionStatusText]: 'bg-sunken text-gray-1',
    [RegisteredByManagerTransactionStatusText]: 'bg-sunken text-gray-1',
}

export function isCashin(moneyPoolTransaction: IMoneyPoolTransactionResult) {
    return moneyPoolTransaction.type.substring(0, 2) === 'cn'
}

export function getTransactionStatusText(item: IMoneyPoolTransactionResult) {
    if (
        item.state === TransactionStateInProgress ||
        item.state === TransactionStateToBank
    )
        return InProgressTransactionStatusText
    else if (!isCashin(item) && item.state === TransactionStateSuccessful) {
        if (item.deed_type === MoneyPoolDeedTypeTransactional)
            return DepositedTransactionStatusText
        else return DepositedByManagerTransactionStatusText
    } else if (
        isCashin(item) &&
        item.state === TransactionStateSuccessful &&
        item.deed_type !== MoneyPoolDeedTypeTransactional
    )
        return RegisteredByManagerTransactionStatusText
    else return ''
}
